import { PropsWithChildren } from 'react';
import { DrycutLogo } from './DrycutLogo';
import { Stack } from './Stack';
import { twMerge } from 'tailwind-merge';

type Props = PropsWithChildren<{
  src: string;
  className?: string;
  logoClasses?: string;
}>;

export function FullscreenImageLayout({
  src,
  className = '',
  logoClasses = '',
  children,
}: Props): JSX.Element {
  const finalLogoClasses = twMerge('hidden m-8 lg:block absolute', logoClasses);
  const finalClasses = twMerge('min-h-screen w-full bg-cover bg-center', className);

  return (
    <Stack className={finalClasses} style={{ backgroundImage: `url(${src})` }}>
      <DrycutLogo width={75} className={finalLogoClasses} />

      {children}
    </Stack>
  );
}
